/* eslint-disable no-restricted-globals */
import React, { Component } from 'react';
import { DEPOSIT_MQR_DEMO_BTN } from '../../configs/B2C.config';
export default class DepositDemoDropdownMenu extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isOpen: false
        };
    }
    componentDidMount() {

    }
    toggleDropDownMenu(count) {
        if (count === 1) {
            window.open(Object.values(DEPOSIT_MQR_DEMO_BTN)[0], '_blank');
        }
        this.setState({ isOpen: !this.state.isOpen });
    }
    itemClick(itmm) {
        window.open(DEPOSIT_MQR_DEMO_BTN[itmm], '_blank')
    }
    render() {
        const languageBtnCount = Object.keys(DEPOSIT_MQR_DEMO_BTN).length;
        return (
            <div className="qrcode-timer1 qrcode-timer-m jus-center cursor h30">
                <div onClick={() => this.toggleDropDownMenu(languageBtnCount)} className='deposit-videolink-btn w-100 text-center videopadding'>
                    Watch video how to deposit?
                </div>
                {this.state.isOpen && (
                    <div className='deposit-videolink deposit-videolink-content'>
                        {!!Object.keys(DEPOSIT_MQR_DEMO_BTN) && Object.keys(DEPOSIT_MQR_DEMO_BTN)?.length > 1 &&

                            Object.keys(DEPOSIT_MQR_DEMO_BTN)?.map((itm, index) => {
                                return (
                                    <div key={index} className={`cursor languagevideo ${languageBtnCount === 2 ? 'twobtn' : languageBtnCount === 3 ? 'threebtn' : ''}`} onClick={() => { this.itemClick(itm) }}>
                                        <p>{itm}</p>
                                    </div>
                                )
                            })
                        }
                    </div>
                )}
            </div>
        )
    }
}
